const prod = {
  apiUrl: 'https://ims-rjcct-scholarsmaster.us-east-2.elasticbeanstalk.com/api',
}

export const environment = prod
